import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SeraDropdownOption } from '../../models/SeraDropdownOption';

@Component({
    selector: 'sera-old-version-dropdown',
    templateUrl: './sera-old-version-dropdown.component.html',
    styleUrls: ['./sera-old-version-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraOldVersionDropdownComponent {
    @Input()
    options: SeraDropdownOption[] = [];

    @Input()
    selectedOptionKey?: string | null;

    @Output()
    optionChangeEvent: EventEmitter<string> = new EventEmitter<string>();

    emitSelectedOption(key: string) {
        this.optionChangeEvent.emit(key);
    }
}
